<app-spinner label="Logging in ..."></app-spinner>
